import { Box } from '@mui/material'
import CustomDialog from 'components/CustomDialog'
import SimpleBarScroll from 'components/SimpleBar'
import React from 'react'
import SmsAssignmentToMachine from './SmsAssignmentToMachine'

const SmsAssignmentDialog = ({ open, handleClose, machine }) => {
  return (
    <CustomDialog
      forceFullScreen={false}
      open={open}
      handleClose={handleClose}
      heading="Manage SMS service providers"
    >
      <Box sx={{ overflow: "hidden" }}>
        <SimpleBarScroll>
          <Box padding={2}>
            <SmsAssignmentToMachine machine={machine} fullGrid={false} />
          </Box>
        </SimpleBarScroll>
      </Box>
    </CustomDialog>
  )
}

export default SmsAssignmentDialog